import { Refinement } from "@siteimprove/alfa-refinement";
import { Column } from "./column.js";
import { Row } from "./row.js";
const { or } = Refinement;
/**
 * @public
 */
export var Group;
(function (Group) {
    Group.isColumn = Column.isGroup;
    Group.isRow = Row.isGroup;
    Group.isGroup = or(Group.isColumn, Group.isRow);
})(Group || (Group = {}));
//# sourceMappingURL=group.js.map